(function () {
  var HEADER_SEARCH_PLACEHOLDER = 'Search:';

  function whenAlgoliaShopifyHooksReady(registerFn) {
    function tryRegister() {
      var shop = typeof window !== 'undefined' ? window.algoliaShopify : null;
      if (!shop || !shop.hooks || typeof shop.hooks.registerHook !== 'function') {
        return false;
      }
      registerFn(shop);
      return true;
    }

    if (tryRegister()) return;

    document.addEventListener('algolia.hooks.initialize', tryRegister);

    var attempts = 0;
    var pollId = setInterval(function () {
      attempts += 1;
      if (tryRegister() || attempts >= 150) {
        clearInterval(pollId);
      }
    }, 100);
  }

  function isKingsleyHeaderAutocompleteContainer(cont) {
    if (!cont) return false;
    var root = document.getElementById('kingsley-header-search-root');
    if (
      cont.closest &&
      (cont.closest('#kingsley-header-search-root') || cont.closest('details-modal.header__search'))
    ) {
      return true;
    }
    return !!(root && typeof root.contains === 'function' && root.contains(cont));
  }

  function registerKingsleyHeaderAutocompleteOptions(shop) {
    if (shop.hooks._kingsleyHeaderBeforeAutocompleteOptions) return;
    shop.hooks._kingsleyHeaderBeforeAutocompleteOptions = true;

    shop.hooks.registerHook('beforeAutocompleteOptions', function (options) {
      if (!options || typeof options !== 'object') return options;

      var cont = options.container;
      if (typeof cont === 'string') {
        try {
          cont = document.querySelector(cont);
        } catch (e) {
          cont = null;
        }
      }

      if (!isKingsleyHeaderAutocompleteContainer(cont)) return options;

      options.detachedMediaQuery = 'none';
      options.placeholder = HEADER_SEARCH_PLACEHOLDER;
      return options;
    });
  }

  whenAlgoliaShopifyHooksReady(registerKingsleyHeaderAutocompleteOptions);
})();
